import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router";
import { DatasourceBrowser } from "src/containers/DatasourceBrowser";

type AssetsSearch = {
    tab?: string;
};

export const Route = createFileRoute("/_layout-nosidebar/assets")({
    component: Assets,
    validateSearch: (search: AssetsSearch & SearchSchemaInput): AssetsSearch => ({
        tab: search.tab,
    }),
});

function Assets() {
    return <DatasourceBrowser kind="asset" />;
}
